export default "__VITE_ASSET__CsHApiRO__"